<template>
    <v-sheet>
        <v-card-title class="no-color">
            <v-form ref="frmSectionEditor" @submit.prevent="" style="width: 100%;">
                <v-container fluid>
                    <v-row>
                        <v-col cols="auto">
                            <v-text-field
                                hide-details="auto"
                                :label="$t('page.sectionEditor.section_name')"
                                outlined
                                dense
                                name="sectionName"
                                @input="updateField('sectionName', $event)"
                                :value="SelectedSection.sectionName"
                                :rules="[ (v) => $inputRules({ value: (v || '') }, 'filled') || $t('page.sectionEditor.errors.section-name-required') ]"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col 
                            cols="auto"
                            class="ml-auto"
                        >
                            <v-switch compact dense
                                hide-details="auto"
                                color="#F00"
                                class="includeFlagSwitch pb-3 px-6"
                                :input-value="SelectedSection.isHidden"
                                :true-value="1"
                                :false-value="0"
                                :label="$t('page.sectionEditor.hide_section')"
                                @change="updateField('isHidden', $event)"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="mr-5">
                    <v-btn @click="deleteSectionConfirm" small>
                        <v-icon left dark>fas fa-trash</v-icon>
                        {{ $t('page.sectionEditor.delete_section', 1) }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        
        <SGSNotificationConfirm v-if="dialog" :notificationMessage="$t('page.sectionEditor.delete-confirmation-message')" @cancel="dialog=false;" @agree="deleteSection()" type='warning'/>
        <SGSNotificationAlert v-if="errorDialog" :notificationMessage="$t(`page.sectionEditor.${errorDialogMessage}`)" @cancel="errorDialog=false;" type='error'/>
    </v-sheet>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";

export default {
    mixins: [apiCalls], //for api redundant operations
    props: ["SelectedSection","RaceId"],
    components: {
        SGSNotificationConfirm,
        SGSNotificationAlert
    },
    data() {
        return {
            dialog: false,
            errorDialog: false,
            errorDialogMessage: '',
            sectionDetailsAPIUrl: '/api/v1/promoter/section',
        };
    },
    methods: {
        deleteSectionConfirm(){
            this.dialog = true;
        },
        updateField(field, value) {
            this.$store.dispatch('addSectionCheckUpdateAction', { field, value, sectionId: this.SelectedSection.id });
        },
        deleteSection: async function() {
            this.dialog = false

            let formData = {
                raceSectionId: this.SelectedSection.id,
                raceId: this.SelectedSection.raceId
            };

            const data = await this.api('delete', '/api/v1/promoter/section', formData);
            
            if(typeof data == 'undefined' || (data && typeof data.error == 'undefined')){
                const response = data;
                if (/^-?\d+$/.test(response)) {
                    //this.$emit("refreshSectionList", this.SelectedSection.raceId, "last");
                    this.$store.dispatch('getSectionsAction',this.RaceId);
                } else {
                    if(response){
                        this.errorDialogMessage = response;
                        this.errorDialog = true;
                        //show general alert for this.$t("page.sectionEditor."+response)
                    }
                }
            }else{
                this.errorDialogMessage = (data && data.error) ? data.error : (typeof data == 'string' ? data : this.$t('page.sectionEditor.error_general'));
                this.errorDialog = true
            }
        }
    }
};
</script>